import { Navigate, type RouteObject } from 'react-router-dom';
import { ComingSoonPage } from '../pages/ComingSoonPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { PreferencesPage } from '../pages/PreferencesPage';
import { StartProcessPage } from '../pages/StartProcessPage';
import { WorkspaceLayout } from '../shell/WorkspaceLayout';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <WorkspaceLayout />,
    children: [
      { index: true, element: <Navigate to="/start" replace /> },
      { path: 'start', element: <StartProcessPage /> },
      { path: 'todo', element: <ComingSoonPage section="todo" /> },
      { path: 'tracking', element: <ComingSoonPage section="tracking" /> },
      { path: 'preferences', element: <PreferencesPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
